import {Trans} from 'react-i18next'
import {ManagerOffer} from '../../../../useOffers'
import {OfferString} from '../OfferString'
import messages from '../../../../../../../../../assets/messages'
import {InfoTooltip} from '../InfoTooltip'
import {Container} from './components/Container'
import {getFormattedAmount} from '../../../../../../../../../common/utils'

type PerformanceFeeProps = {
  fees: ManagerOffer['settings']['performanceFees'],
  currency: string,
}

export const PerformanceFee = ({fees, currency}: PerformanceFeeProps) => {
  const {levels} = fees
  const tooltipContent = fees.levels.map(level => (
    <>
      <div>
        <Trans {...messages.singleLevelPerformanceFee} values={{fee: level.value}} />
        <br />
        <Trans {...messages.equityAmount} values={{amount: getFormattedAmount({amount: level.level, currency})}} />
      </div>
      <br />
    </>
  ))

  const firstFeeLevel = fees.levels[0]

  if (!firstFeeLevel) return null

  return (
    <Container>
      <OfferString>
        <Trans {...messages.singleLevelPerformanceFee} values={{fee: firstFeeLevel.value}} />
        <br />
        <Trans {...messages.equityAmount} values={{amount: getFormattedAmount({amount: firstFeeLevel.level, currency})}} />
      </OfferString>
      {levels.length > 1 ? <InfoTooltip content={tooltipContent} /> : null}
    </Container>
  )
}
